import { APPLICATION_STATES } from '../../../constants'
import { getEnv } from '../../../../../config/env'

const REACT_APP_WP_URL = getEnv('REACT_APP_WP_URL')

export const BUDGET_GRID_ROW_ITEMS = [
  {
    label: 'pages.budget.view.panel1.detail.grid.item2',
    valueParsed: (model, intl) =>
      intl.formatNumber(model['presupuesto_exterior']['distancia_real'], {
        style: 'unit',
        unit: 'meter',
      }),
  },
  {
    label: 'pages.budget.view.panel1.detail.grid.item3',
    valueParsed: (model, intl) =>
      intl.formatNumber(model['presupuesto_exterior']['ampliacion_asumida_por_cliente'], {
        style: 'unit',
        unit: 'meter',
      }),
  },
]

export const URL_CANCEL_LINK = `${REACT_APP_WP_URL}/no-me-interesa`

export const BUDGET_STEP_UNCANCELLABLE_STATES = {
  [APPLICATION_STATES.FINISHED.KEY]: APPLICATION_STATES.FINISHED.DESCRIPTION,
  [APPLICATION_STATES.REJECTED_SURVEY.KEY]: APPLICATION_STATES.REJECTED_SURVEY.DESCRIPTION,
  [APPLICATION_STATES.REJECTED.KEY]: APPLICATION_STATES.REJECTED.DESCRIPTION,
  [APPLICATION_STATES.REJECTED_2.KEY]: APPLICATION_STATES.REJECTED_2.DESCRIPTION,
  [APPLICATION_STATES.REJECTED_NORMALIZATION]: true,
}

export const MUST_ANSWER_CANCEL_REQUEST = {
  [APPLICATION_STATES.CLIENT_CANCEL_PENDING.KEY]: true,
}

export const CAN_SELECT_INSTALLER = {
  [APPLICATION_STATES.CREATED.KEY]: true,
  [APPLICATION_STATES.REVIEW.KEY]: true,
  [APPLICATION_STATES.NOT_ASSIGNED.KEY]: true,
  [APPLICATION_STATES.VALIDATION_PENDING.KEY]: true,
  [APPLICATION_STATES.ASSIGNED.KEY]: true,
  [APPLICATION_STATES.BUDGET_SENDED.KEY]: true,
  [APPLICATION_STATES.BUDGET_ACCEPTED.KEY]: true,
  [APPLICATION_STATES.PAYMENT_VALIDATION.KEY]: true,
  [APPLICATION_STATES.BUDGET_PAID.KEY]: true,
}
